// extracted by mini-css-extract-plugin
export var searchHeader = "_1s-0";
export var searchHeaderDark = "_1s-1";